import * as TYPES from './types';

export function mergeEntities(entities, module) {
  return {
    type: TYPES.MERGE_ENTITIES,
    payload: entities,
    module,
  };
}

export function updateEntities(module, entity, id, data) {
  return {
    type: TYPES.UPDATE_ENTITIES,
    payload: {
      entity,
      data,
      id,
    },
    module,
  };
}

export function clearEntities(module, entity) {
  return {
    type: TYPES.CLEAR_ENTITIES,
    payload: {
      entity,
    },
    module,
  };
}
